// extracted by mini-css-extract-plugin
export default {"skillBar":"SkillBar_skillBar__RxTq9","label":"SkillBar_label__zWi5w","barContainer":"SkillBar_barContainer__MKSt8","bar":"SkillBar_bar__HQiOD"};